import React, { useState } from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import CustomInputLabel from "../customInputLabel";

const CustomPasswordInput = ({
  id,
  name,
  title,
  isRequired = true, 
  value,
  setValue,
  type = "password",
  placeholder = "Enter Your Password",
  passwordMatch,
  required = false, 
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = (event) => event.preventDefault();

  const showHelperText = () => {
    if (passwordMatch === false) {
      return "Password does not match"; 
    }
    return ""; 
  };

  return (
    <>
      <CustomInputLabel title={title} isRequired={isRequired} />
      <TextField
        id={id}
        name={name}
        placeholder={placeholder}
        type={showPassword && type === "password" ? "text" : type}
        value={value} 
        onChange={(e) => setValue(e.target.value)}
        fullWidth
        variant="outlined"
        InputProps={{
          endAdornment: type === "password" && (
            <InputAdornment position="end">
              <IconButton
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
        helperText={showHelperText()}
        FormHelperTextProps={{
          sx: {
            color: (required && value === "") || passwordMatch === false ? "red" : "green",
          },
        }}
      />
    </>
  );
};

export default CustomPasswordInput;

